import React, { useState, useEffect } from "react";
import api from "../../../api/api";
import ParentPanel from "../panel/ParentPanel";
import "../styles/classwork.css";

const ClassworkPage = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [classworkList, setClassworkList] = useState([]);
  const [activeClass, setActiveClass] = useState(null);

  useEffect(() => {
    fetchStudentClasswork();
  }, []);

  const fetchStudentClasswork = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return;

      const res = await api.get("/api/classwork");

      setClassworkList(res.data);
    } catch (err) {
      console.error("❌ Error fetching classwork:", err.response || err);
    }
  };

  const handleCardClick = (cls) => setActiveClass(cls);
  const closeDetailView = () => setActiveClass(null);

  return (
    <>
      <ParentPanel onToggle={setIsSidebarCollapsed} />

      <div className={`cw-main-container ${isSidebarCollapsed ? "cw-collapsed" : ""}`}>
        <h2 className="cw-page-title">Classwork</h2>

        {/* Cards */}
        {!activeClass && (
          <div className="cw-card-grid">
            {classworkList.length > 0 ? (
              classworkList.map((cls) => (
                <div
                  key={cls.id}
                  className="cw-card-item"
                  style={{ backgroundColor: cls.color || "#00bfff" }}
                  onClick={() => handleCardClick(cls)}
                >
                  <h4 className="cw-card-subject">{cls.subject}</h4>
                </div>
              ))
            ) : (
              <p style={{ color: "#777" }}>ℹ️ No classwork available</p>
            )}
          </div>
        )}

        {/* Detail Modal */}
        {activeClass && (
          <div className="cw-detail-overlay">
            <div className="cw-detail-box">
              <button className="cw-close-btn" onClick={closeDetailView}>✖</button>

              <div className="cw-detail-header" style={{ backgroundColor: activeClass.color }}>
                <h2>{activeClass.subject}</h2>
              </div>

              <table className="cw-detail-table">
                <tbody>
                  <tr>
                    <td className="cw-detail-label">Topic</td>
                    <td>{activeClass.topic}</td>
                  </tr>
                  <tr>
                    <td className="cw-detail-label">Date</td>
                    <td>{new Date(activeClass.date).toLocaleDateString()}</td>
                  </tr>
                  {activeClass.comment && (
                    <tr>
                      <td className="cw-detail-label">Teacher Comment</td>
                      <td>💬 {activeClass.comment}</td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Images */}
              {activeClass.images && activeClass.images.length > 0 && (
                <div className="cw-detail-media">
                  {activeClass.images.map((img, idx) => (
                    <img
                      key={idx}
                      src={img}

                      alt={`${activeClass.subject} media ${idx + 1}`}
                      className="cw-detail-image"
                    />
                  ))}
                </div>
              )}

              {/* Video */}
              {activeClass.video && (
                activeClass.video.includes("youtube.com") || activeClass.video.includes("youtu.be") ? (
                  <iframe
                    className="cw-detail-video"
                    src={activeClass.video}
                    title={activeClass.topic}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                ) : (
                  <video controls className="cw-detail-video">
                    <source src={`${API_BASE}/uploads/${activeClass.video}`} type="video/mp4" />
                  </video>
                )
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ClassworkPage;
